import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainNavToggleService {
  private isOpen = new BehaviorSubject<boolean>(false);

  public isOpen$ = this.isOpen.asObservable();

  constructor() {}

  get isMainNavOpen() {
    return this.isOpen.getValue();
  }

  toggleMainNav() {
    this.isOpen.next(!this.isOpen.value);
  }
}
